import { EventEntity } from '../schema/EventEntity';
import { EventsCache } from '../schema/EventsCache';
import { trace } from 'owa-trace';

export function removeEvents<T extends EventEntity>(
    shouldRemove: (event: T) => boolean,
    cache: EventsCache<T>
): T[] {
    const { events } = cache;
    let eventsRemoved = 0;
    const removedEvents: T[] = [];
    for (let i = events.length - 1; i >= 0; i--) {
        const cacheItem = events[i];
        if (shouldRemove(cacheItem)) {
            removedEvents.push(cacheItem);
            trace.info(`[owa-events-cache] Removing cached event at index ${i}: ${cacheItem.Key}`);

            events.splice(i, 1);
            eventsRemoved++;
        }
    }

    cleanLockedEventInfoForEvents(removedEvents, cache);
    trace.info(`[owa-events-cache] Unloaded ${eventsRemoved} items from cache`);

    return removedEvents.reverse();
}

function cleanLockedEventInfoForEvents(events: EventEntity[], cache: EventsCache<EventEntity>) {
    [...cache.locksInfo.keys()].forEach(lockId => {
        const lockInfo = cache.locksInfo.get(lockId);

        // For all the locks remove the corresponding lock for the events
        events.forEach(event => delete lockInfo.lockedEvents[event.Key]);
    });
}
